
import * as defaultImport from "@splunk/themes/variables";
export * from "@splunk/themes/variables";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
